import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getMethod } from "../../services/ApiCallMethods";

export const fetchDistributionHistory = createAsyncThunk(
  "distributionHistory/fetchDistributionHistory",
  async ({ clientId, productMasterId }, { rejectWithValue }) => {
    try {
      let url = `/account/getMonthlyInvestment?clientId=${clientId}&metric=distributions`;

      if (productMasterId) {
        url += `&productMasterId=${productMasterId}`;
      }

      const response = await getMethod(url);
      const data = await response.json();

      if (!response.ok || data?.error) {
        return rejectWithValue(data?.error || "Failed to fetch distribution history");
      }

      return data;
    } catch (error) {
      return rejectWithValue(error?.message || "Something went wrong");
    }
  }
);

const distributionHistorySlice = createSlice({
  name: "distributionHistory",

  initialState: {
    loading: false,
    error: null,
    distributionHistory: {},
  },

  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchDistributionHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchDistributionHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.distributionHistory = action.payload?.data || {};
      })

      .addCase(fetchDistributionHistory.rejected, (state, action) => {
        state.loading = false;
        state.distributionHistory = {};
        state.error = action.payload || "Failed to load distribution history";
      });
  },
});

export default distributionHistorySlice.reducer;
